import * as React from 'react'

import Svg, {
  Defs,
  LinearGradient,
  Path,
  RadialGradient,
  Stop,
} from 'react-native-svg'

function BlueGiftBox(props) {
  return (
    <Svg
      width={37}
      height={41}
      viewBox="0 0 37 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M18.32 40.538l1.274.1c.331.026.663.013.99-.041l5.057-.827.082-.013 5.877-.962.036-.003 4.605-.747V12.056l-4.633-.003H31.6l-5.877.294-.087.044-7.108.274-.21 27.872h.001z"
        fill="url(#paint0_radial_1010_37492)"
      />
      <Path
        d="M.439 13.723v24.256c0 .868.664 1.577 1.524 1.628l16.865 1.007c.683.04 1.264-.528 1.264-1.233V14.11c0-.707-.552-1.292-1.236-1.31l-16.988-.476a1.39 1.39 0 00-1.43 1.399z"
        fill="url(#paint1_radial_1010_37492)"
      />
      <Path
        d="M36.206 12.062l-16.114.765-18.223-.51 18.683-.61 15.654.355z"
        fill="#D4E5FE"
      />
      <Path
        d="M14.18 40.325l-6.254-.373v-27.47l6.254.175v27.668z"
        fill="#145CC5"
      />
      <Path
        d="M13.898 40.308l-5.972-.356v-27.47l5.972.168v27.658zM25.807 12.445v27.34l5.728-.975V12.29l-1.824-.035-3.904.19z"
        fill="#346BC5"
      />
      <Path
        d="M25.22 11.812l-17.431.994h6.267l15.24-.902-4.076-.092z"
        fill="#346BC5"
      />
      <Path
        d="M16.737 10.98c-.406-2.493-.703-4.316-2.326-6-.685-.71-1.433-1.485-2.659-1.69-1.41-.236-3.21.32-3.703 1.476-.469 1.097.634 1.812.166 3.071C7.744 9.104 6.37 9.077 6.22 10.1c-.128.866.715 1.85 1.566 2.31 1.47.795 2.305-.324 5.176-.143 1.978.125 3.12.753 3.655.12.255-.302.23-.72.12-1.405h-.001z"
        fill="url(#paint2_radial_1010_37492)"
      />
      <Path
        d="M8.879 10.003c1.772-.68 2.68-2.16 3.466-1.81.698.311.272 1.61 1.092 2.667.75.965 2.123 1.195 3.343 1.196a.789.789 0 01-.162.328c-.535.634-1.677.006-3.655-.12-2.871-.18-3.706.94-5.176.143-.78-.422-1.552-1.284-1.576-2.092.828.089 1.75.04 2.668-.312z"
        fill="url(#paint3_linear_1010_37492)"
        opacity={0.3}
      />
      <Path
        d="M27.443 4.808c-1.192-.943-2.45.109-3.917-.928-1.486-1.051-1.055-2.737-2.208-3.215-1.339-.555-3.323 1.139-4.273 2.214-2.411 2.731-3.544 7.58-1.638 9.287.716.64 2.741.376 6.764-.178 4.598-.633 5.26-1.086 5.7-1.68 1.185-1.599.922-4.432-.428-5.5z"
        fill="url(#paint4_radial_1010_37492)"
      />
      <Path
        d="M19.894 6.855c.663-.21.965.55 2.327.857.25.056 2.651.56 3.94-.952.512-.6.752-1.407.724-2.262.187.066.373.164.558.31 1.35 1.068 1.613 3.9.427 5.5-.44.594-1.102 1.047-5.7 1.68-4.021.554-6.047.818-6.763.178a2.3 2.3 0 01-.263-.284c.965-.032 1.977-.266 2.708-.979 1.41-1.374.915-3.691 2.042-4.048z"
        fill="url(#paint5_linear_1010_37492)"
        opacity={0.3}
      />
      <Path
        d="M19.61 12.328l6.114.232 5.885-.28-1.902-.035-8.33-.148-1.766.231z"
        fill="#346BC5"
      />
      <Defs>
        <RadialGradient
          id="paint0_radial_1010_37492"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(15.13344 25.89933 -20.98256 12.26048 19.682 13.915)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_1010_37492"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(16.59634 25.62206 -21.74427 14.08456 1.933 14.166)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint2_radial_1010_37492"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(43.554 -.814 11.77) scale(12.8702 11.2262)"
        >
          <Stop stopColor="#FFCA86" />
          <Stop offset={1} stopColor="#9B6929" />
        </RadialGradient>
        <LinearGradient
          id="paint3_linear_1010_37492"
          x1={5.64331}
          y1={5.42385}
          x2={12.7875}
          y2={12.831}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#AB316D" />
          <Stop offset={1} stopColor="#792D3D" />
        </LinearGradient>
        <RadialGradient
          id="paint4_radial_1010_37492"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(42.023 6.69 22.361) scale(16.7787 14.5751)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <LinearGradient
          id="paint5_linear_1010_37492"
          x1={23.3975}
          y1={8.76653}
          x2={4.48171}
          y2={5.97728}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#AB316D" />
          <Stop offset={1} stopColor="#792D3D" />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}

export default BlueGiftBox
